import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useAtom, useAtomValue } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import { CimodeEnabledContext, useAppTranslator, } from "@plansoft-configuration-renderer/localization";
export const cimodeEnabledState = atomWithStorage("setting:cimodeEnabledState", false, createJSONStorage(), { getOnInit: true });
export function CimodeEnabledSwitch() {
    const t = useAppTranslator();
    const [enabled, setEnabled] = useAtom(cimodeEnabledState);
    return (_jsx(FormGroup, { sx: { m: 1 }, children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: enabled, onChange: () => setEnabled(!enabled) }), label: _jsx(Fragment, { children: t("ConfigurationRenderer:Settings.enableCiMode.name", "Enable ci mode") }) }) }));
}
export function CimodeEnabledProvider({ children, }) {
    const enabled = useAtomValue(cimodeEnabledState);
    return (_jsx(CimodeEnabledContext.Provider, { value: enabled, children: children }));
}
//# sourceMappingURL=CimodeEnabled.js.map